import type {ThreadStatus, ThreadType} from 'nutshell-graphql-types';

import {colors} from '../../colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {CircleMinusIcon} from '../../icon/svg/circle-minus-icon';
// @ts-expect-error - imported from .js/.jsx file
import {ReplyClockIcon} from '../../icon/svg/reply-clock-icon';
import {Stack} from '../../layout/stack/stack';
import {Body} from '../../typography/body';

import type {Recipient, UpdateAction} from '../types';

import {RecipientDisplay} from './recipient-display';
import {ThreadHeaderPickers} from './thread-header-pickers';

import styles from './thread-header.module.css';

interface Props {
    recipient: Recipient | null | undefined;
    selectRecipientComponent?: React.ReactNode;
    isBlocked?: boolean;
    isAwaitingReply?: boolean;
    canReopen: boolean;
    canArchive: boolean;
    onUpdateStatus: (status: UpdateAction) => Promise<any> | null | undefined;
    status: ThreadStatus | null | undefined;
    assigneeButton: React.ReactNode | null | undefined;
    isSmall?: boolean;
    openedFromEntityId?: string;
    onSaveContactName?: (name: string) => void;
    isLoadingChannelEvents?: boolean;
    shouldShowStatusDot?: boolean;
    threadType?: ThreadType | null | undefined;
    shouldHidePickers?: boolean;
}

export function ThreadHeader(props: Props) {
    return (
        <div className={props.isSmall ? styles['container--small'] : styles.container}>
            <Stack isHorizontal={true} spacing={8} alignItems='center'>
                {props.recipient ? (
                    <RecipientDisplay
                        recipient={props.recipient}
                        isSmall={props.isSmall}
                        isLinkable={props.recipient.id !== props.openedFromEntityId}
                        onSaveContactName={props.onSaveContactName}
                        isLoadingChannelEvents={props.isLoadingChannelEvents}
                        shouldShowStatusDot={props.shouldShowStatusDot}
                        threadType={props.threadType}
                    />
                ) : undefined}
                {props.selectRecipientComponent}
                {props.isBlocked && (
                    <div className='flex align-center'>
                        <span className='mr-4'>
                            <CircleMinusIcon
                                color={colors.error}
                                size={15}
                                alignCenter={true}
                                data-tip='Recipient has opted out'
                                data-place='bottom'
                            />
                        </span>
                        {props.isSmall ? undefined : <Body color='error'>Blocked</Body>}
                    </div>
                )}
                {props.isAwaitingReply && !props.isSmall && (
                    <div className='flex align-center'>
                        <span className='mr-4'>
                            <ReplyClockIcon size={16} alignCenter={true} />
                        </span>
                        <Body>Awaiting your reply</Body>
                    </div>
                )}
            </Stack>
            {!props.shouldHidePickers && (
                <ThreadHeaderPickers
                    assigneeButton={props.assigneeButton}
                    onUpdateStatus={props.onUpdateStatus}
                    status={props.status}
                    canReopen={props.canReopen}
                    canArchive={props.canArchive}
                    isSmall={props.isSmall}
                />
            )}
        </div>
    );
}
